module.exports = __webpack_public_path__ + "static/media/seqirus.01df4fe5.png";